export default "__VITE_ASSET__CHXXxxBa__"